var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top color",
    style: ({
      backgroundColor: _vm.boxBodyColor
    })
  }, [(_vm.displayMode == 2) ? _c('img', {
    staticClass: "title_img",
    attrs: {
      "src": _vm.logoUrl,
      "alt": "公司logo"
    }
  }) : _c('p', {
    staticClass: "title_2"
  }, [(_vm.companyName == '' || _vm.companyName == null) ? _c('span') : (_vm.companyName.length > 10) ? _c('el-tooltip', {
    attrs: {
      "content": _vm.companyName,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.companyName.substring(0, 10) + '...'))])]) : _c('span', [_vm._v(_vm._s(_vm.companyName))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.kefuis),
      expression: "kefuis"
    }],
    staticStyle: {
      "margin-right": "20px"
    },
    on: {
      "click": _vm.kefugo
    }
  }, [_vm._v("在线客服")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.kefuis),
      expression: "kefuis"
    }],
    staticClass: "kefu",
    attrs: {
      "height": "18px",
      "src": require("../../assets/workorder/kefu.png")
    },
    on: {
      "click": _vm.kefugo
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.callis),
      expression: "callis"
    }],
    staticStyle: {
      "margin-right": "40px"
    },
    on: {
      "click": _vm.callgo
    }
  }, [_vm._v("客服电话")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.callis),
      expression: "callis"
    }],
    staticClass: "kefu1",
    attrs: {
      "height": "18px",
      "src": "/pc/static/assets/callbtn.png"
    },
    on: {
      "click": _vm.callgo
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b116bf0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workorder/top.vue
// module id = ul0r
// module chunks = 1